export const registedDropdownOptions = [
 
  {
    "id": "Unlimited",
    "displayName": "Unlimited"
  },
  {
    "id": "Limited",
    "displayName": "Limited"
  }
]

export const chargeDropdownOptions = [
  {
    "id": "Unpaid",
    "displayName": "Unpaid"
  },
  {
    "id": "Paid",
    "displayName": "Paid"
  }
]

export const locationDropdownOptions = [
  {
    "id": "Xian",
    "displayName": "Xian"
  },
  {
    "id": "ChengDu",
    "displayName": "ChengDu"
  },
  {
    "id": "ShangHai",
    "displayName": "ShangHai"
  },
  {
    "id": "BeiJing",
    "displayName": "BeiJing"
  },
  {
    "id": "YunNan",
    "displayName": "YunNan"
  }
]

export const FORM_NAME = {
  ACTIVITY_FORM: 'ActivityForm',
  REGISTER_FORM: 'RegisterForm'
}

export const ACTIVITY_STATUS = {
  STATUS_LABEL: {
    OPEN: 'Open',
    CLOSED: 'Closed',
    NEW: 'New',
  },
}

export const FILTER_CONTROL_CATEGORY = {
  INPUT: 'input',
  SELECT: 'select'
}

export const ROUTES_PATH = {
  ROOT: '/',
  MY_ACTIVITY: '/my-activity',
  ACTIVITY_INFO: '/activityInfo',
  MY_ACTIVITY_REGISTERED_DETAIL: '/activityInfo/registered',
  MY_ACTIVITY_PUBLISHED_DETAIL: '/activityInfo/published',
  ADD_ACTIVITY: '/activityInfoForm/add',
  EDIT_ACTIVITY: '/activityInfoForm/edit',
}

export const DYNAMIC_SEGMENT = {
  ID: '/:id'
}

export const SHOW_TYPE = {
  ACTIVITY_VIEW_REGISTERED : 'activity_registered_view_detail'
}

export const PAGINATION_OPTIONS = {
  GP_LIST: {
    SPAN: 6
  },
  ACTIVITY_GUEST_LIST: {
    SPAN: 10
  }
};

export const MODULE = {
  MY_ACTIVITIES: {
    REGISTERED: 'REGISTERED',
    PUBLISHED: 'PUBLISHED',
    FAVORITE: 'FAVORITE',
    ACTIVITY_DETAIL: 'ACTIVITY_DETAIL',
  }
}

export const FILTER_OPTIONS = {
  PERIOD: [
    {
    "id": "All",
    "displayName": "All Time"
    },
    {
      "id": "Last12Month",
      "displayName": "Last 1 Year"
    },
    {
      "id": "Last6Month",
      "displayName": "Last 6 Months"
    },
    {
      "id": "Last3Month",
      "displayName": "Last 3 Months"
    }
  ],
  PAYMENT: [
    {
      "id": "All",
      "displayName": "All Charge Types"
    }, {
      "id": "Free",
      "displayName": "Free"
    }, {
      "id": "Paid",
      "displayName": "Cost"
    }
  ],
  CATEGORY: [
    {
      "id": "0",
      "displayName": "All Category"
    },
    {
      "id": "1",
      "displayName": "Personal"
    },
    {
      "id": "2",
      "displayName": "Club"
    },
    {
      "id": "3",
      "displayName": "Company"
    },
  ],
  STATUS: [
    {
      "id": "All",
      "displayName": "All Status"
    },
    {
      "id": "New",
      "displayName": "New"
    },
    {
      "id": "Open",
      "displayName": "Open"
    },
    {
      "id": "Closed",
      "displayName": "Closed"
    },
  ]
}

export const CHORES = {
  DELAY: 500
}

export const ACITVITY_MODULE = {
  title: "",
  startTime: "",
  endTime: "",
  registerStartTime: "",
  registerDeadline: "",
  registerNumberLimitType: "",
  registerNumberLimit: 0,
  chargeType: "",
  chargeAmount: 0,
  isOnlineActivity: false,
  city: "",
  address: "",
  coverId: 0,
  descriptionObject: [],
  videoUrls: [],
  documentIds: [],
  imageIds: [],
  publisherCategory: 0,
  meetingUrl: "",
  meetingID: "",
  passcode: "",
  registerSetting: {
    isCollectInformation: true,
    isNameRequired: true,
    isPhoneRequired: true,
    isEmailRequired: true,
    isNoteRequired: true,
    isAllowInviteGuests: false,
    maxInvitedGuests: 0
  },
  activityAllowRoles: [
  ],
  groupIds: [],
  recipientEmailAddresses: [],
  emailNotificationSentCount: 0,
};
export const PUBLISHER_CATEGORY = {
  PERSONAL: 'Personal',
  CLUB: 'Club',
  COMPANY: 'Company',
}

export const REGISERED_SUB_MENU = {
  REGISTERED: 'Registered',
  PENDING_FEEDBACK: 'PendingFeedback',
  CLOSED: 'Closed',
}

export const ROLE_NAME_MAPPING = {
  Development: 'Dev',
  // eslint-disable-next-line
  ['Quality Assurance']: 'QA',
  // eslint-disable-next-line
  ['Product & Design']: 'Design',
  // eslint-disable-next-line
  ['Management & Leadership']: 'Management',
  // eslint-disable-next-line
  ['Operation & Support']: 'DevOps',
  // eslint-disable-next-line
  ['Consulting & Architecture']: 'Architecture',
  // eslint-disable-next-line
  ['Data & Analytics']: 'BA'
}